import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAtomValue, useSetAtom, getDefaultStore } from "jotai";
import { Header } from "components/common/header/Header";
import Svgs from "assets/svgs";
import {
    withdrawStepAtom,
    withdrawStepStackAtom,
    popWithdrawStepAtom,
    resetWithdrawData,
} from "store/withdrawStore";
import { requestApp, WEB_TO_APP } from "common/webview";
import { clearAuth } from "common/auth";
import { WithdrawStep1 } from "components/withdraw/WithdrawStep1";
import { WithdrawStep2 } from "components/withdraw/WithdrawStep2";
import { WithdrawStep3 } from "components/withdraw/WithdrawStep3";
import { WithdrawDone } from "components/withdraw/WithdrawDone";
import './Withdraw.css';

export const Withdraw = () => {
    const { t } = useTranslation();
    const step = useAtomValue(withdrawStepAtom);
    const popStep = useSetAtom(popWithdrawStepAtom);
    const reset = useSetAtom(resetWithdrawData);

    // 닫기 — webview 측 인증 메모리 정리 후 네이티브에 close 통지
    // (in-memory 변수라 webview 종료 시 자동 소멸이지만 명시적으로 비워 안전망)
    const handleClose = () => {
        clearAuth();
        requestApp(WEB_TO_APP.WITHDRAW_CLOSE);
    };

    // 뒤로가기 — 이전 step. 더 이상 없으면 닫기
    const handleBack = () => {
        const prev = popStep();
        if (prev === null) handleClose();
    };

    // 물리 뒤로가기/브라우저 뒤로가기
    useEffect(() => {
        const onPopState = () => {
            // closure stale 값 대신 jotai store 에서 최신 step 읽기
            const store = getDefaultStore();
            const stack = store.get(withdrawStepStackAtom);
            const currentStep = stack[stack.length - 1];

            // Step4(완료 안내) — dead-end. 뒤로가기를 step3 재진입으로 처리하지 않고 즉시 종료 시그널.
            //  (이미 백엔드 deactivate + native cleanup 완료된 상태라 step3 재노출은 부자연스러움)
            if (currentStep === 4) {
                requestApp(WEB_TO_APP.WITHDRAW_DONE);
                return;
            }

            const prev = popStep();
            if (prev === null) handleClose();
        };
        window.addEventListener("popstate", onPopState);
        return () => window.removeEventListener("popstate", onPopState);
    }, [popStep]);

    // 페이지 진입 시 상태 초기화
    useEffect(() => {
        reset();
    }, []);

    // step 전환 시 스크롤 초기화
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [step]);

    const isDone = step === 4;

    return (
        <div className="withdraw-wrapper">
            <Header
                title={t("withdraw.headerTitle")}
                leftBtn={isDone ? undefined : { svg: Svgs.IcBack24, func: handleBack }}
            />

            {step === 1 && <WithdrawStep1 />}
            {step === 2 && <WithdrawStep2 />}
            {step === 3 && <WithdrawStep3 />}
            {step === 4 && <WithdrawDone />}
        </div>
    );
};
